module.exports = __webpack_public_path__ + "static/media/robot.febaa0cc.png";